import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { initializeWaiterOrdersSSE } from '../../redux/slice/waiterSlice';

const SSEProvider = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const cleanupSSE = dispatch(initializeWaiterOrdersSSE());
    return cleanupSSE;
  }, [dispatch]);

  return children;
};

export default SSEProvider;